<script setup lang="ts">
/**
 * Team pasó a vivir dentro de Settings (`/settings/team`). Esta ruta queda solo
 * para no romper enlaces guardados de la versión anterior.
 */
definePage({
  meta: { requiresAuth: true },
  redirect: { name: 'settings-team' },
});
</script>

<template>
  <div />
</template>
